import { bodyHasAnyClass, createCookie, isAndroid, isIos, isSafari, readCookie, waitForElement } from './helpers';

window.paceOptions = {
    ajax: false, // disabled
    document: false, // disabled
    eventLag: false, // disabled
    elements: {
        selectors: ['header', 'main', 'footer'],
    },
};

// check if the device is in standalone mode
const isInStandaloneMode = () => {
    return (
        ('standalone' in window.navigator && window.navigator.standalone) ||
        window.matchMedia('(display-mode: standalone)').matches
    );
};

window.updatePageLoadingState = (isLoading) => {
    if (isLoading) {
        document.body?.classList?.add('pwa-page-loading');
    } else {
        document.body?.classList?.remove('pwa-page-loading');
    }
};

// Create a function that checks the readyState
function checkReadyState() {
    const timer = setInterval(() => {
        // Stop pace loader when the document is fully loaded
        if (document.readyState === 'complete') {
            Pace.stop(); // Stop Pace once readyState is complete
            clearInterval(timer); // Clear the timer
            updatePageLoadingState(false);
        }
    }, 500); // Run the check every 500ms
}

// Call the function to start the timer
checkReadyState();

window.addEventListener('pageshow', (event) => {
    // Handle the back navigation
    if (event.persisted) {
        checkReadyState();
    }
});

window.addEventListener('load', () => {
    // Send page visit updates to OneSignal
    const toBeTrackedPageClasses = ['page-template-template-career-area', 'page-template-template-hub', 'single-jobs'];

    const navigationType = performance?.getEntriesByType('navigation')[0]?.type;

    if (bodyHasAnyClass(toBeTrackedPageClasses) && navigationType == 'navigate') {
        const pathArray = window.location.pathname.split('/');
        const topic = pathArray?.reduce((prev, part) => (!part ? prev : part), null);
        window.notificationManager.updatePageTags(topic);
    }

    if (typeof OneSignal !== 'undefined') {
        function displayOneSignalNotificationTooltip() {
            const tooltipElement = document.querySelector('.onesignal-bell-launcher-message-body');
            if (tooltipElement) {
                const blockedMessage = window.OneSignal.notifyButton.options.text['tip.state.blocked'];
                tooltipElement.innerHTML = blockedMessage;

                const tooltipContainer = tooltipElement.parentElement;
                const tooltipOpenedClass = 'onesignal-bell-launcher-message-opened';

                if (!tooltipContainer.classList.contains(tooltipOpenedClass)) {
                    tooltipContainer.classList.add(tooltipOpenedClass);

                    setTimeout(() => {
                        tooltipContainer.classList.remove(tooltipOpenedClass);
                    }, 3000); // Tooltip stays visible for 3 seconds
                }
            }
        }

        setTimeout(displayOneSignalNotificationTooltip, 2000);
    }
    if (isInStandaloneMode()) {
        document.body?.classList?.add('pwa-standalone-mode');
        const jobContainer = document.querySelector('body:not(.search-jobs) .job-result-section .job-card-list');
        if (jobContainer) {
            const job_links = jobContainer.querySelectorAll('a[target="_blank"]');
            job_links.forEach((link) => {
                link.removeAttribute('target');
            });
        }
    }

    // Add fallback for broken imges
    {
        // Get all image elements on the page
        const images = document.querySelectorAll('img');
        const fallbackImageUrl = pwaData.fallbackImageUrl;

        images.forEach((image) => {
            const setFallbackImage = () => {
                const width = image?.getAttribute('width') || image?.clientWidth || 150;
                const height = image?.getAttribute('height') || image?.clientHeight || 150;
                image.src = fallbackImageUrl;
                image.classList.add('fallback-image');
                image.parentNode.classList.add('fallback-image-parent');
                image.style.width = `${width}px`;
                image.style.height = `${height}px`;
            };
            image.addEventListener('abort', () => {
                setFallbackImage();
            });
            image.addEventListener('error', () => {
                setFallbackImage();
            });
            // Handle the case where the image is already in a failed state
            if (image.complete && image.naturalWidth === 0) {
                setFallbackImage();
            }
        });
    }

    {
        const groups = document.querySelectorAll('.business-resource-groups .group');
        let fallbackFound = false;
        let i = 0;

        groups.forEach((group, index) => {
            if (group.querySelector('.fallback-image')) {
                fallbackFound = true;
                i++;
            } else {
                fallbackFound = false;
            }

            if (fallbackFound && i > 1) {
                groups[index].classList.add('hide');
            }
        });
    }

    // Set class on body based on network state changes
    {
        const checkNetworkStatus = () => {
            // Select the body element
            const body = document.body;

            // Add a custom class based on online/offline status
            if (navigator.onLine) {
                body.classList.remove('pwa-offline');
                body.classList.add('pwa-online');
                document.querySelectorAll('a[href^="http"]').forEach(function (link) {
                    if (link.hostname !== window.location.hostname) {
                        link.style.pointerEvents = '';
                    }
                });
            } else {
                body.classList.remove('pwa-online');
                body.classList.add('pwa-offline');
                document.querySelectorAll('a[href^="http"]').forEach(function (link) {
                    if (link.hostname !== window.location.hostname) {
                        link.style.pointerEvents = 'none';
                    }
                });
            }
        };

        // Listen for the 'offline' event and run the function when it occurs
        window.addEventListener('online', checkNetworkStatus);
        window.addEventListener('offline', checkNetworkStatus);

        // Initial run to set the class based on the initial state
        checkNetworkStatus();
    }

    // Show install prompt
    {
        const pwaPromptStorageKey = 'pwa-install-prompt-shown';
        const installPrompt = document.querySelector('.pwa-install-container');
        const btnClose = installPrompt?.querySelector('.btn-close');
        const btnInstall = installPrompt?.querySelector('.install-cta');
        const footerElement = document.querySelector('footer');

        const showPWAInstallModal = () => {
            const isIosSafari = isIos() && isSafari();
            const pwaPromptStorageKeyValue = readCookie(pwaPromptStorageKey);
            const installModalShown = pwaPromptStorageKeyValue ? JSON.parse(pwaPromptStorageKeyValue) : false;

            const isMobile = (isIosSafari || isAndroid()) && !isInStandaloneMode();
            const isDesktop = !isMobile && !isInStandaloneMode();
            return (isMobile || isDesktop) && !installModalShown;
        };

        if (showPWAInstallModal()) {
            installPrompt?.classList.add('show');
        }

        btnClose?.addEventListener('click', () => {
            installPrompt?.classList.remove('show');
            createCookie(pwaPromptStorageKey, 'true');
        });

        btnInstall?.addEventListener('click', () => {
            createCookie(pwaPromptStorageKey, 'true');
        });

        // Bind scroll event to check if prompt is overlapping on footer
        window.addEventListener('scroll', (e) => {
            // Do nothing if install prompt is not shown or user is on mobile.
            if (!showPWAInstallModal() || window.innerWidth < 768) return;

            if (window.innerHeight + window.scrollY > footerElement.offsetTop) {
                installPrompt?.classList.remove('show');
            } else {
                installPrompt?.classList.add('show');
            }
        });
    }

    // pwa mobile nav
    {
        const pwaMobileNav = document.querySelector('.pwa-mobile-nav');
        const footer = document.querySelector('footer');
        const paceLoader = document.querySelector('.pace');
        const backButton = pwaMobileNav.querySelector('#back-btn');
        const refreshButton = pwaMobileNav.querySelector('#refresh-btn');

        if (pwaMobileNav) {
            const pwaNavHeight = pwaMobileNav.offsetHeight;
            document.body.style.setProperty('--pwa-nav-height', `${pwaNavHeight}px`);
        }

        function checkBackButton() {
            if (backButton) {
                if (window.history.length <= 1) {
                    backButton.disabled = true;
                } else {
                    backButton.disabled = false;
                }
            }
        }

        function checkdevice_icon() {
            const iphone_icon = document.querySelector('.iphone_icon');
            const android_icon = document.querySelector('.android_icon');
            if (isIos() || isSafari()) {
                iphone_icon?.classList.remove('hide');
            } else {
                android_icon?.classList.remove('hide');
            }
        }

        function updateFooterPadding() {
            if (pwaMobileNav && footer) {
                const pwaMobileNavHeight = pwaMobileNav.offsetHeight;
                footer.style.paddingBottom = `${pwaMobileNavHeight}px`;
            }
        }

        checkdevice_icon();
        checkBackButton();
        updateFooterPadding();
        updatePageLoadingState(false);

        window.addEventListener('resize', updateFooterPadding);

        // Listen for popstate events when the active history changes
        window.addEventListener('popstate', checkBackButton);

        document.addEventListener('keydown', (e) => {
            if (e.key == 'Escape') {
                document.querySelector('.pace')?.classList?.add('pace-inactive');
                updatePageLoadingState(false);
            }
        });

        backButton?.addEventListener('click', function (e) {
            e.stopPropagation();
            if (window.history.length > 1) {
                window.history.back();
                setTimeout(checkBackButton, 100);
            }
        });

        refreshButton?.addEventListener('click', function () {
            if (document.body.classList.contains('pwa-page-loading')) {
                setTimeout(() => {
                    window.stop();
                    updatePageLoadingState(false);
                    paceLoader.classList.add('pace-inactive');
                }, 0);
            } else {
                setTimeout(() => {
                    updatePageLoadingState(true);
                    window.location.reload();
                }, 0);
            }
        });
    }

    // User guide
    {
        function activateOsSpecificGuide() {
            let deviceType = 'desktop';

            if (isIos()) {
                deviceType = 'ios';
            } else if (isAndroid()) {
                deviceType = 'android';
            } else if (isSafari()) {
                deviceType = 'mac-safari';
            }

            const osSpecificGuide = document.querySelector(`[data-id="${deviceType}"]`);

            if (osSpecificGuide) {
                osSpecificGuide.querySelector('.faq-accordian')?.classList.add('active');
                osSpecificGuide.querySelector('.faq-question-label')?.setAttribute('aria-expanded', 'true');
                if (osSpecificGuide.querySelector('.faq-accordian-content')) {
                    osSpecificGuide.querySelector('.faq-accordian-content').style.display = 'block';
                }
            }
        }
        activateOsSpecificGuide();
    }

    {
        function checkCurrentDevice() {
            let deviceType = 'desktop';

            if (isIos()) {
                deviceType = 'ios';
            } else if (isAndroid()) {
                deviceType = 'android';
            } else if (isSafari()) {
                deviceType = 'mac-safari';
            }

            // Add device specific class to the body
            document.body.classList.add(`device-${deviceType}`);
        }

        checkCurrentDevice();
    }

    // Notification permission check
    {
        const subscriptionID = localStorage.getItem('subscriptionID');
        const allowNotificationButton = document.querySelector('.allow-notification');
        const cookiebtnElement = document.querySelector('#onetrust-accept-btn-handler');

        if (allowNotificationButton) {
            allowNotificationButton.addEventListener('click', function () {
                // Request permission for push notifications
                if (typeof OneSignal !== 'undefined') {
                    OneSignal.Notifications.requestPermission();
                }
            });
        }

        function pushSubscriptionChangeListener(event) {
            if (event.current.token) {
                // Close the job alert popup
                const jobAlertPopupCloseBtn = document.querySelector('#filter-popup-form .mfp-close');
                setTimeout(() => {
                    jobAlertPopupCloseBtn?.click();
                }, 1000);

                if (typeof OneSignal !== 'undefined') {
                    if (OneSignal.Notifications.permission) {
                        if (subscriptionID) {
                            // Call the subscribeUser (login) method to register for push notifications
                            notificationManager.setExternalUserId(subscriptionID);
                        }

                        // Send tags to OneSignal
                        const businessAreaCookie = readCookie('business-area');
                        let businessAreaName = null;

                        if (businessAreaCookie) {
                            const businessArea = JSON.parse(businessAreaCookie);
                            businessAreaName = businessArea.name;
                        }

                        if (typeof businessAreaName === 'string' && businessAreaName.trim() !== '') {
                            notificationManager.sendTag('business_area', businessAreaName);
                        }
                        notificationManager.sendTag('jobfeed_type', readCookie('search-jobs-type'));
                        notificationManager.updateLocationTags();
                        notificationManager.updatePageTags();
                    }
                }
            }
        }
        if (typeof OneSignal !== 'undefined') {
            OneSignal.User.PushSubscription.addEventListener('change', pushSubscriptionChangeListener);
        }
        if (typeof OneSignal !== 'undefined') {
            function permissionChangeListener(permission) {
                updateBodyClass(permission);
            }

            OneSignal.Notifications.addEventListener('permissionChange', permissionChangeListener);
        }
        function updateBodyClass(permission) {
            document.body.classList.remove('push-permission-default', 'push-permission-granted', 'push-permission-undefined');

            if (permission || Notification.permission === 'granted') {
                document.body.classList.add('push-permission-granted');
            } else {
                document.body.classList.add('push-permission-default');
            }
        }

        // Check the current notification permission status and update the body class
        if (typeof OneSignal !== 'undefined') {
            updateBodyClass(OneSignal.Notifications.permission);
        } else {
            document.body.classList.add('push-permission-undefined');
        }

        cookiebtnElement?.addEventListener('click', function (e) {
            updateBodyClass(OneSignal.Notifications.permission);    
        });

        function checkBrowser() {
            let browserType = '';

            // Detect browsers using the user agent
            const userAgent = navigator.userAgent;

            if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1) {
                browserType = 'chrome';
            } else if (userAgent.indexOf('Edg') > -1) {
                browserType = 'edge';
            }
            if (browserType) {
                document.body.classList.add(`browser-${browserType}`);
            }
        }
        checkBrowser();
    }

    // Function to add aria-labels to the OneSignal notification banner buttons
    function addAriaLabelsToOneSignalBanner() {
        const allowButton = document.getElementById('onesignal-slidedown-allow-button');
        const cancelButton = document.getElementById('onesignal-slidedown-cancel-button');

        if (allowButton) {
            allowButton.setAttribute('aria-label', 'Allow notifications for the latest news and updates');
        }
        if (cancelButton) {
            cancelButton.setAttribute('aria-label', 'Decline notifications for the latest news and updates');
            cancelButton.addEventListener('click', function () {
                announceDeclineMessage();
            });
        }
    }

    // Function to enhance accessibility for the notification bell icon
    function notificationBellIconAlly() {
        const bellButtonContainer = document.querySelector('.onesignal-bell-launcher');

        if (bellButtonContainer) {
            const bellButton = bellButtonContainer?.querySelector('.onesignal-bell-launcher-button');

            if (bellButton) {
                // Function to update tabindex based on active class
                function updateTabindex() {
                    if (bellButtonContainer.classList.contains('onesignal-bell-launcher-active')) {
                        bellButton.setAttribute('tabindex', '0');
                        bellButton.setAttribute('role', 'button');
                        bellButton.setAttribute('aria-label', 'Enable notifications by clicking this bell icon');
                        bellButton.removeAttribute('aria-hidden');
                    } else {
                        bellButton.removeAttribute('tabindex');
                        // below attributes are removed to prevent screen readers from announcing the bell icon when it's not active in mobile
                        bellButton.removeAttribute('role');
                        bellButton.removeAttribute('aria-label');
                        bellButton.setAttribute('aria-hidden', 'true');
                    }
                }

                // Initial tabindex check
                updateTabindex();

                // Listen for class changes on bellButtonContainer using MutationObserver
                const observer = new MutationObserver(function (mutationsList) {
                    for (const mutation of mutationsList) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                            // Update tabindex when class changes
                            updateTabindex();
                        }
                    }
                });

                // Observe changes in the class attribute of bellButtonContainer
                observer.observe(bellButtonContainer, { attributes: true });

                // Add keyboard accessibility for 'Enter' and 'Space' keys
                bellButton.addEventListener('keydown', function (event) {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        bellButton.click();
                    }
                });
            }
        }
    }

    // Create an ARIA live region for dynamic announcements
    function createLiveRegion() {
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('id', 'notification-live-region');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('role', 'status');
        liveRegion.classList.add('sr-only');
        document.body.appendChild(liveRegion);
    }

    // Announce message to screen readers
    function announceDeclineMessage() {
        const liveRegion = document.getElementById('notification-live-region');
        if (liveRegion) {
            liveRegion.textContent =
                'You have declined notifications for the latest news and updates. You can still enable them by clicking on the notification bell icon.';

            // Remove the live region after a short delay
            setTimeout(() => {
                liveRegion.remove();
            }, 8000);
        }
    }

    // wait for one signal as its loaded asynchronously
    waitForElement('#onesignal-slidedown-container', () => {
        addAriaLabelsToOneSignalBanner();
    });

    waitForElement('.onesignal-bell-launcher', () => {
        notificationBellIconAlly();
        const bodyMessage = document.querySelector('.onesignal-bell-launcher-message-body');
        if (bodyMessage) {
            bodyMessage.setAttribute('aria-hidden', 'true');
        }
    });

    // Initialize live region on page load
    createLiveRegion();
});
function addAccessibilityAttributes(element) {
    element.parentElement.setAttribute('role', 'alert');
    element.parentElement.setAttribute('aria-live', 'polite');
}
waitForElement('#snackbar-msg', addAccessibilityAttributes);
document.querySelector('.snackbar')?.classList.add('snackbar--show');

setTimeout(() => {
    document.querySelector('.snackbar')?.classList.remove('snackbar--show');
}, 5000); 